export const SEARCH_HIDE   = 'app:search:hide';
export const SEARCH_SHOW   = 'app:search:show';
export const SEARCH_TOGGLE = 'app:search:toggle';

export const LISTING_COUNT_UPDATE = 'app:listing:count:update';
